import { useEffect, useState } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom';
import * as moment from 'moment'

const modeloDatos = {
    reporteID: 0, moduloID: 0, nombreModulo: '', nombreBoton: '', htmLcode: '', scriptcode: '' }


const CuadreCajaNCF = () => {
    let { Pedido } = useParams();
    const param = "var API ='http://localhost:32214/api/VentasMantenimiento/listaArticulos'";
    const [htmlContent, setHtmlContent] = useState("");
    const [loaded, setLoaded] = useState(false);
    const [ListadoReporte, SetListadoReporte] = useState(modeloDatos);
    const [htmlReporte, setHtmlReporte] = useState("");

    const obtenerReportes = async () => {
        let response = await fetch(Api + "Administracion/Reporteria/3");

        if (response.ok) {
            let data = await response.json()
            var d = data.filter(e => e.reporteID == Pedido).map(x =>x)
            SetListadoReporte(d[0])
            loadHTMLFile(d[0].htmLcode, d[0].scriptcode); 
        }
    }

 
    


    const loadHTMLFile = async (e,s)  => {
        try {
          
            if (e != null) {
                setHtmlContent(e);
              
               scrip(s)
            } else {
                console.error('No se pudo cargar el archivo HTML');
            }
        } catch (error) {
            console.error('Error al cargar el archivo HTML', error);
        }
    };

    // Cargar el archivo HTML cuando el componente se monte
    useEffect(() => {
        obtenerReportes()
        
    }, []);


    const scrip =(s) => {
        
            // Crear un elemento script para ejecutar el JS cargado
            const script = document.createElement('script');
            script.innerHTML = `

${s}  

        // Aquí va el código JavaScript que necesitas ejecutar.
        console.log('JavaScript cargado y ejecutado');
        // Puedes ejecutar el código JavaScript dentro del HTML cargado aquí.
      `;
        document.body.appendChild(script);
           
        
         };
//        useEffect(() => {
  //      if (htmlContent && !loaded) {
  //          // Crear un elemento script para ejecutar el JS cargado
  //          const script = document.createElement('script');
  //          script.innerHTML = `
  //${ListadoReporte.scriptcode}
  //      // Aquí va el código JavaScript que necesitas ejecutar.
  //      console.log('JavaScript cargado y ejecutado');
  //      // Puedes ejecutar el código JavaScript dentro del HTML cargado aquí.
  //    `;
  //          document.body.appendChild(script);
  //          setLoaded(true);
  //      }
  //  }, [htmlContent, loaded]);


    // Función para imprimir el contenido HTML
    const handlePrint = () => {
        const printWindow = window.open('', '', 'height=600,width=800');
        printWindow.document.write('<html><head><title>Imprimir</title></head><body>');
        printWindow.document.write(htmlContent);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
    };

   
 

    return (

        <>
            {/*  <iframe
                src="/Informes/Inventario/listaarticulos.html"
                title="Contenido HTML"
                style={{ width: '100%', height: '1100px', border: 'none' }}
            />*/}

            {/* Botón para imprimir */}
            <button onClick={handlePrint}>Imprimir</button>

            <div
                dangerouslySetInnerHTML={{
                    __html: htmlContent,
                }}
            >
        </div>

          

        </>
        )

}
export default CuadreCajaNCF;